document.addEventListener("DOMContentLoaded", function () {
    //  ############################## Sliders  ##################### 
    let whatSwiper = new Swiper(".whatslider", {
        autoplay: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    let customerlove = new Swiper(".customerlove", {
        slidesPerView: 1,
        // initialSlide: 10,
        autoplay: true,
        grabCursor: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2.4,
                spaceBetween: 20,
                centeredSlides: true,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            1349: {
                slidesPerView: 4.4,
                spaceBetween: 30
            }
        }
    });
    document.querySelectorAll('.card_slider').forEach((sliderEl) => {
        const showMobilePagination = sliderEl.dataset.mobilePagination === 'true';
        const paginationEl = sliderEl.querySelector('.card_slider-pagination');

        const getRealSlideCount = (swiper) => {
            return swiper.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length;
        };

        const getThreeDotActive = (realIndex, realTotal) => {
            if (realTotal <= 1) return 0;
            const ratio = realIndex / (realTotal - 1);
            if (ratio < 1 / 3) return 0;
            if (ratio < 2 / 3) return 1;
            return 2;
        };

        const renderThreeDots = (swiper) => {
            if (!paginationEl) return;
            const realTotal = getRealSlideCount(swiper);
            const active = getThreeDotActive(swiper.realIndex, realTotal);
            paginationEl.innerHTML = [0, 1, 2]
                .map(
                    (i) =>
                        `<button type="button" class="card_slider-dot${
                            i === active ? ' is-active' : ''
                        }" data-dot-index="${i}" aria-label="Slide group ${i + 1}"></button>`
                )
                .join('');
        };

        const swiper = new Swiper(sliderEl, {
            slidesPerView: 2,
            grabCursor: true,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: sliderEl.querySelector('.nb'),
                prevEl: sliderEl.querySelector('.pn'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 3,
                },
                1349: {
                    slidesPerView: 4,
                },
            },
            on: showMobilePagination && paginationEl
                ? {
                      init(sw) {
                          renderThreeDots(sw);
                      },
                      slideChange(sw) {
                          renderThreeDots(sw);
                      },
                  }
                : undefined,
        });

        if (showMobilePagination && paginationEl) {
            paginationEl.addEventListener('click', (event) => {
                const btn = event.target.closest('[data-dot-index]');
                if (!btn) return;
                const dotIndex = Number(btn.dataset.dotIndex);
                const realTotal = getRealSlideCount(swiper);
                if (realTotal <= 1) return;
                const target =
                    dotIndex === 0
                        ? 0
                        : dotIndex === 2
                          ? realTotal - 1
                          : Math.floor((realTotal - 1) / 2);
                swiper.slideToLoop(target);
            });
        }
    });



});


//   ????????????????????????????????????????????????????????????????????????????????????????????????????????????? NOt Pull ??????????????????????????????????? 
// single product page functionality
// Simple thumbnail click to change main image
function changeImage(element) {
    document.getElementById('mainImage').src = element.src;
    document.querySelectorAll('.thumbnail-img').forEach(img => img.classList.remove('active'));
    element.classList.add('active');
}

// Size selection
document.querySelectorAll('.size-btn:not(.out-of-stock)').forEach(btn => {
    btn.addEventListener('click', function () {
        document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
    });
});

// Color selection
document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', function () {
        document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
        this.classList.add('active');
    });
});

// counter selection
let counterHtml = document.getElementById('counterNumber90');
console.log(counterHtml)
function minusCount() {
    if (counterHtml.innerText > 0) {
        counterHtml.innerText--;
    }
}
function plusCount() {
    counterHtml.innerText++;
}